import Status from '@/constants/Status';

export default class UpdateStatusModel {
  userId?: string;

  status?: Status;

  constructor(userId: string, status: Status) {
    this.userId = userId;
    this.status = status;
  }
}
